module.exports = __webpack_public_path__ + "img/Ora-Ani_2Tunnel_kl.97bba5d5.jpg";